import React, { ComponentType, CSSProperties } from 'react'
import 'styled-components/macro'

import { CloseIcon } from '../../icons/CloseIcon'

import {
  CloseIconWrapper,
  Container,
  Description,
  Heading,
  StyledButton
} from './styledComponents'

interface CTACardProps {
  icon?: ComponentType
  heading?: string
  description?: string
  buttonText?: string
  onClickButton?: () => void
  containerCSS?: CSSProperties
  onClickCloseIcon?: () => void
  bgImage?: string
  isLoading?: boolean
  shouldShowCloseIcon?: boolean
  renderChildren?: () => JSX.Element
  descriptionTextCss?: CSSProperties
}

export const CTACard = (props: CTACardProps) => {
  const {
    icon: Icon,
    heading,
    description,
    buttonText,
    onClickButton,
    bgImage,
    onClickCloseIcon,
    isLoading,
    containerCSS,
    shouldShowCloseIcon,
    renderChildren,
    descriptionTextCss
  } = props

  const onButtonClick = () => {
    onClickButton && onClickButton()
  }

  return (
    <Container css={containerCSS} bgImage={bgImage}>
      {renderChildren ? (
        <>
          <Icon />
          <Heading>{heading}</Heading>
          {renderChildren()}
        </>
      ) : (
        <>
          {shouldShowCloseIcon && (
            <CloseIconWrapper onClick={onClickCloseIcon}>
              <CloseIcon />
            </CloseIconWrapper>
          )}
          <Icon />
          <Heading>{heading}</Heading>
          <Description css={descriptionTextCss}>{description}</Description>
        </>
      )}
      <StyledButton isLoading={isLoading} onClick={onButtonClick}>
        {buttonText}
      </StyledButton>
    </Container>
  )
}
